function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Manages the updates of all `<ReactTimeAgo/>` elements on a page.
export default {
  listeners: [],
  add: function add(listener) {
    var _this = this;

    var wasIdle = this.listeners.length === 0;

    _add(this.listeners, listener);

    if (wasIdle) {
      this.start();
    } else {
      this.scheduleNextTick();
    }

    return {
      stop: function stop() {
        remove(_this.listeners, listener);

        if (_this.listeners.length === 0) {
          _this.stop();
        } else {
          _this.scheduleNextTick();
        }
      },
      forceUpdate: function forceUpdate() {
        triggerListener(listener);
      }
    };
  },
  tick: function tick() {
    // This line isn't required but I personally clear timer IDs when they're triggered.
    this.scheduledTick = undefined; // Trigger every listener that should be triggered.

    var now = Date.now();

    for (var _iterator = _createForOfIteratorHelperLoose(this.listeners), _step; !(_step = _iterator()).done;) {
      var listener = _step.value;

      if (now >= listener.updateTime) {
        triggerListener(listener);
      }
    }
  },
  scheduleNextTick: function scheduleNextTick() {
    var _this2 = this;

    this.cancelNextTick();

    if (this.listeners.length === 0) {
      return;
    }

    var earliestUpdateTime = this.listeners[0].updateTime;
    var i = 1;

    while (i < this.listeners.length) {
      if (this.listeners[i].updateTime < earliestUpdateTime) {
        earliestUpdateTime = this.listeners[i].updateTime;
      }

      i++;
    }

    this.scheduledTick = setTimeout(function () {
      _this2.tick();

      _this2.scheduleNextTick();
    }, earliestUpdateTime - Date.now());
  },
  cancelNextTick: function cancelNextTick() {
    clearTimeout(this.scheduledTick); // This line isn't required but I personally clear timer IDs when they're triggered.

    this.scheduledTick = undefined;
  },
  start: function start() {
    this.scheduleNextTick();
  },
  stop: function stop() {
    this.cancelNextTick();
  }
};

function triggerListener(listener) {
  var _listener$getNewValue = listener.getNewValueAndNextUpdateTime(),
      _listener$getNewValue2 = _slicedToArray(_listener$getNewValue, 2),
      value = _listener$getNewValue2[0],
      updateTime = _listener$getNewValue2[1];

  listener.setValue(value);
  listener.updateTime = updateTime;
} // Adds a listener.


function _add(listeners, listener) {
  listeners.push(listener);
} // Removes a listener.


function remove(listeners, listener) {
  var i = findIndex(listeners, listener);
  listeners.splice(i, 1);
} // Finds an index of `listener` in `listeners` array.


function findIndex(listeners, listener) {
  return listeners.indexOf(listener);
}
//# sourceMappingURL=Updater.js.map